/**
 * BRXEmbeddablesLoader
 *
 * Loads the Embeddables provider bundle and initialises the flow for the
 * section's <savvy> element. Separated from the wrapper so the overlay and
 * flow-detection paths can be tested without triggering an external fetch.
 *
 * Usage:
 *   window.BRXEmbeddablesLoader.load(sectionRoot, {
 *     onError: function(detail) { /* detail.stage: 'script_load' | 'fetch_timeout' | 'fetch_error' | 'bad_payload' *\/ }
 *   });
 */
(function () {
    var FETCH_TIMEOUT_MS = 8000;
    // Fixed on purpose: never take the engine origin from the page URL, or any
    // link could load third-party script onto the site.
    var ENGINE_URL = 'https://engine.embeddables.com';

    function load(root, options) {
        var savvyEl = root ? root.querySelector('savvy') : null;
        if (!savvyEl) return;

        var onError = (options && options.onError) || function () {};

        function initEmbeddables() {
            var allUserData = {};
            try { allUserData = JSON.parse(localStorage.getItem('SavvyFormUserData') || '{}'); } catch (e) {}

            var attrs = {};
            for (var i = 0; i < savvyEl.attributes.length; i++) {
                var attr = savvyEl.attributes[i];
                attrs[attr.name] = attr.value;
            }

            var flowId = attrs.id;
            if (flowId && allUserData[flowId]) {
                var userData = {};
                var stored = allUserData[flowId] || {};
                for (var key in stored) {
                    if (!Object.prototype.hasOwnProperty.call(stored, key)) continue;
                    if (key === 'current_page_id' || key.indexOf('split_') === 0) {
                        userData[key] = stored[key];
                    }
                }
                attrs.userData = userData;
            }

            var url = ENGINE_URL + '/init?load=' + encodeURIComponent(JSON.stringify({
                embeddablesToLoad: [attrs],
                originUrl: window.location.href
            }));

            var timedOut  = false;
            var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
            var timeoutId = controller ? setTimeout(function () {
                timedOut = true;
                controller.abort();
            }, FETCH_TIMEOUT_MS) : null;

            fetch(url, controller ? { signal: controller.signal } : undefined)
                .then(function (res) { return res.json(); })
                .then(function (response) {
                    clearTimeout(timeoutId);
                    if (!response || !response.init_js) {
                        onError({ stage: 'bad_payload', message: 'Missing init payload' });
                        return;
                    }
                    try {
                        eval('(' + response.init_js + ')(response.embeddables_data)');
                    } catch (e) {
                        onError({ stage: 'bad_payload', message: e && e.message });
                    }
                })
                .catch(function (e) {
                    clearTimeout(timeoutId);
                    onError({ stage: timedOut ? 'fetch_timeout' : 'fetch_error', message: e && e.message });
                });
        }

        var existing = document.querySelector('script[data-embeddables-bundle="true"]');
        if (existing) {
            if (existing.getAttribute('data-loaded') === 'true') { initEmbeddables(); return; }
            existing.addEventListener('load', initEmbeddables, { once: true });
            return;
        }

        var script = document.createElement('script');
        script.src = ENGINE_URL + '/bundle.js';
        script.async = true;
        script.setAttribute('data-embeddables-bundle', 'true');
        script.addEventListener('load', function () {
            script.setAttribute('data-loaded', 'true');
            initEmbeddables();
        }, { once: true });
        script.addEventListener('error', function () {
            if (script.parentNode) script.parentNode.removeChild(script);
            onError({ stage: 'script_load' });
        }, { once: true });
        document.head.appendChild(script);
    }

    window.BRXEmbeddablesLoader = { load: load };
})();
